module.exports = __webpack_public_path__ + "img/rubihorn.33c65bb7.jpg";